module.exports = __webpack_public_path__ + "res/loading-spinner.gif";